<template>
    <div class="">
		 <div class="d-flex align-items-center justify-content-between">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item"><router-link to="/dashboard">Dashboard</router-link></li>
                    <li class="breadcrumb-item"><router-link to="/schools">Schools</router-link></li>
                    <li class="breadcrumb-item active" aria-current="page">
                        <span v-if="status">New School</span>
                        <span v-else>Update School</span>
                    </li>
                </ol>
                <label class="form-label">
                    <h4 v-if="status">New School</h4>
                    <h4 v-else>Update School</h4>
                </label>
            </div>
             <router-link to="/schools" type="submit" class="btn d-flex align-item-center btn-primary"><i class="ri-list-check me-1"></i> SCHOOLS</router-link>
        </div>
        <form @submit.prevent="submitForm">
            <div class="card br-16 card-shadow">
                <div class="card-body mb-3">
                    <div class="row g-3">
                        <div class="col-md-12">
                            <label class="form-label">School Name</label><span class="text-danger"> *</span>
                            <input type="text" placeholder="School Name" class="form-control" :class="{ 'is-invalid': errors.school_name }" v-model="school.school_name" ref="school_name" />
                            <span v-if="errors.school_name" class="invalid-feedback">{{ errors.school_name }}</span>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Board</label><span class="text-danger"> *</span>
                            <select class="form-control" :class="{ 'is-invalid': errors.board }" v-model="school.board">
                                <option value="">Select Board</option>
                                <option value="CBSC">CBSC</option>
                                <option value="State">State</option>
                                <option value="ICSC">ICSC</option>
                            </select>
                            <span v-if="errors.board" class="invalid-feedback">{{ errors.board}}</span>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">District</label><span class="text-danger"> *</span>
                            <Search
                                :class="{ 'is-invalid': errors?.district_id }"
                                :customClass="{ 'is-invalid': errors?.district_id }"
                                :initialize="school.district_id"
                                id="district_id"
                                label="district"
                                placeholder="Select District"
                                :data=" districts"
                                @input=" district => school.district_id = district"
                            >
                            </Search>
                            <span v-if="errors.district_id" class="invalid-feedback">{{ errors.district_id }}</span>
                        </div>
                          <div class="col-md-3">
                            <label class="form-label">Pin Code</label><span class="text-danger"> *</span>
                            <input type="text" placeholder="Pin Code" class="form-control" :class="{ 'is-invalid': errors.pincode }" v-model="school.pincode" />
                            <span v-if="errors.pincode" class="invalid-feedback">{{ errors.pincode}}</span>
                        </div>
                        <div class="col-md-3">
                            <label class="form-label">Principal</label>
                            <input type="text" placeholder="Principal" class="form-control" :class="{ 'is-invalid': errors.principal }" v-model="school.principal" />
                            <span v-if="errors.principal" class="invalid-feedback">{{ errors.principal}}</span>
                        </div>

                        <div class="col-md-3">
                            <label class="form-label">Email</label>
                            <input type="text" placeholder="Email" class="form-control" :class="{ 'is-invalid': errors.email }" v-model="school.email" />
                            <span v-if="errors.email" class="invalid-feedback">{{ errors.email}}</span>
                        </div>

                        <div class="col-md-3">
                            <label class="form-label">Phone Number</label>
                            <input type="text" placeholder="Phone Number" class="form-control" :class="{ 'is-invalid': errors.phone_number }" v-model="school.phone_number" />
                            <span v-if="errors.phone_number" class="invalid-feedback">{{ errors.phone_number}}</span>
                        </div>

                        <div class="col-md-3">
                            <label class="form-label">Place</label><span class="text-danger"> *</span>
                            <input type="text" placeholder="Place" class="form-control" :class="{ 'is-invalid': errors.place }" v-model="school.place" />
                            <span v-if="errors.place" class="invalid-feedback">{{ errors.place}}</span>
                        </div>

                        <div class="col-md-3">
                            <label class="form-label">Web Site</label>
                            <input type="text" placeholder="Web Site" class="form-control" :class="{ 'is-invalid': errors.web_site }" v-model="school.web_site" />
                            <span v-if="errors.web_site" class="invalid-feedback">{{ errors.web_site}}</span>
                        </div>
                         <div class="col-md-12">
                           <label class="form-label">Address</label><span class="text-danger"> *</span>
                                <textarea rows="2" type="text" placeholder="Address" class="form-control" v-model="school.address" :class="{ 'is-invalid': errors.address }"></textarea>
                                <span v-if="errors.address" class="invalid-feedback">{{ errors.address}}</span>
                        </div>
                        <div class="col-md-12">
                             <div class="text-end">
                                <button type="reset" class="btn btn-danger me-2" @click.prevent="discard()"><i class="ri-close-line icon_hgt"></i> DISCARD</button>
                                <button v-if="status" type="submit" class="btn btn-primary"><i class="ri-save-line icon_hgt"></i> SUBMIT</button>
                                <button v-else type="submit" class="btn btn-primary"><i class="ri-save-line icon_hgt"></i> UPDATE</button>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </form>

        <template v-if="!status && school.school_id">
            <div class="d-flex align-items-center justify-content-between mt-3 mb-2">
                <h4 class="mb-0">Comments</h4>
                <a
                    type="button"
                    class="btn d-flex align-item-center btn-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#schoolAddCommentModal"
                    href="javascript:void(0)"
                    @click="openAddComment"
                >Add Comment</a>
            </div>

            <div class="card br-16 card-shadow" v-if="session_comments.length">
                <div class="card-body">
                    <div class="table-responsive table-responsive-sm">
                        <table class="table table-sm text-nowrap table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th class="text-center">#</th>
                                    <th>User</th>
                                    <th>Visited Date</th>
                                    <th>Reminder Date & Time</th>
                                    <th class="text-center">Present Stage</th>
                                    <th class="text-center">Next Stage</th>
                                    <th>Comment</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(session_comment, key) in session_comments" :key="key">
                                    <td class="text-center">{{ commentMeta.from + key }}</td>
                                    <td>{{ session_comment?.User?.name || '—' }}</td>
                                    <td>{{ changeDate(session_comment?.date_time) }}</td>
                                    <td>{{ changeDateTime(session_comment?.reminder_date_time) }}</td>
                                    <td class="text-center">{{ session_comment?.PresentStage?.stage }}</td>
                                    <td class="text-center">{{ session_comment?.NextStage?.stage }}</td>
                                    <td class="text-wrap">{{ session_comment?.comment }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="mt-3">
                        <div class="d-flex justify-content-between align-items-center">
                            <select class="form-select from-select-sm width-75" v-model="commentMeta.per_page" @change="onCommentPerPageChange">
                                <option>10</option>
                                <option>15</option>
                                <option>20</option>
                                <option>25</option>
                                <option>30</option>
                            </select>
                            <span>Showing {{ commentMeta.from }} to {{ commentMeta.to }} of {{ commentMeta.totalRows }} entries</span>
                            <Pagination
                                :maxPage="commentMeta.maxPage"
                                :totalPages="commentMeta.lastPage"
                                :currentPage="commentMeta.page"
                                @pagechanged="onCommentPageChange"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <div class="modal fade" id="schoolAddCommentModal" tabindex="-1" aria-labelledby="schoolAddCommentLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="schoolAddCommentLabel">Add Comment</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="closeSchoolCommentModal"></button>
                    </div>
                    <div class="modal-body">
                        <label class="form-label">User</label>
                        <select class="form-control mb-2" v-model="newComment.user_id">
                            <option value="">Select User</option>
                            <option v-for="user in users" :key="user.user_id" :value="user.user_id">{{ user.name }}</option>
                        </select>
                        <label class="form-label">Present Stage</label>
                        <select class="form-control mb-2" v-model="newComment.stage_id">
                            <option value="">Select Present Stage</option>
                            <option v-for="stage in stages" :key="'present-' + stage.stage_id" :value="stage.stage_id">{{ stage.stage }}</option>
                        </select>
                        <label class="form-label">Next Stage</label>
                        <select class="form-control mb-2" v-model="newComment.next_stage_id">
                            <option value="">Select Next Stage</option>
                            <option v-for="stage in stages" :key="'next-' + stage.stage_id" :value="stage.stage_id">{{ stage.stage }}</option>
                        </select>
                        <label class="form-label">Comment</label>
                        <textarea class="form-control mb-2" rows="3" v-model="newComment.comment" placeholder="Comment"></textarea>
                        <label class="form-label">Reminder Date & Time</label>
                        <input class="form-control" type="datetime-local" v-model="newComment.reminder_date_time" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="saveComment">Submit</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Search from "@/components/Search.vue";
import Pagination from "@/components/Pagination.vue";
import moment from "moment";
    export default {
        name: "Schools.Create",
        components: { Search, Pagination },
        data() {
            return {
                school: {
                    school_id: "",
                    school_name: "",
                    board: "",
                    district_id: "",
                    address: "",
                    place: "",
                    pincode: "",
                    principal: "",
                    email:"",
                    phone_number:"",
                    web_site:"",
                    user_id: this.$store?.getters?.user?.user_id
                },
                status: true,
                schools: [],
                districts:[],
                errors: [],
                users: [],
                stages: [],
                session_comments: [],
                commentMeta: {
                    search: "",
                    order_by: "desc",
                    keyword: "session_comment_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    school_id: "",
                },
                newComment: {
                    user_id: "",
                    stage_id: "",
                    next_stage_id: "",
                    comment: "",
                    reminder_date_time: "",
                },
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.getDistrict();
                if (to.name == "Schools.Create") {
                    vm.$refs.school_name.focus();
                } else {
                    vm.status = false;
                    let uri = { uri: "school/viewSchool", data: { school_id: to.params.school_id } };
                    vm.$store
                        .dispatch("post", uri)
                        .then(function (response) {
                            vm.school = response.data.data;
                            vm.school.user_id = vm.$store?.getters?.user?.user_id;
                            vm.commentMeta.school_id = to.params.school_id;
                            vm.loadComments();
                        })
                        .catch(function (error) {
                            vm.errors = error.response.data.errors;
                            vm.$store.dispatch("error", error.response.data.message);
                        });
                }
            });
        },
    methods: {
            getDistrict() {
				 let vm = this;
				let loader = vm.$loading.show();
				vm.$store.dispatch("post", { uri: "district/getDistricts" })
                .then((response) => {
                    console.log("distt",response.data.data)
                    loader.hide();
                    vm.districts = response.data.data;
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
			},
            changeDate(date_time) {
                if (!date_time) return "";
                return moment(date_time).format("DD-MM-YYYY hh:mm:ss A");
            },
            changeDateTime(date_time) {
                if (!date_time) return "";
                return moment.utc(date_time).format("DD-MM-YYYY hh:mm:ss A");
            },
            loadComments() {
                let vm = this;
                if (!vm.commentMeta.school_id) return;
                vm.$store
                    .dispatch("post", { uri: "sessionComments/paginateSessionComments", data: vm.commentMeta })
                    .then(function (response) {
                        vm.session_comments = response.data.data.data || [];
                        vm.commentMeta.totalRows = response.data.data.meta.total;
                        vm.commentMeta.lastPage = response.data.data.meta.lastPage;
                        vm.commentMeta.from = response.data.data.meta.from || 0;
                        const end = vm.commentMeta.from + Number(vm.commentMeta.per_page) - 1;
                        vm.commentMeta.to = end > vm.commentMeta.totalRows ? vm.commentMeta.totalRows : end;
                        vm.commentMeta.maxPage = vm.commentMeta.lastPage >= 3 ? 3 : vm.commentMeta.lastPage;
                    })
                    .catch(function (error) {
                        vm.$store.dispatch("error", error.response?.data?.message || "Unable to load comments");
                    });
            },
            onCommentPageChange(page) {
                this.commentMeta.page = page;
                this.loadComments();
            },
            onCommentPerPageChange() {
                this.commentMeta.page = 1;
                this.loadComments();
            },
            openAddComment() {
                this.newComment = {
                    user_id: "",
                    stage_id: "",
                    next_stage_id: "",
                    comment: "",
                    reminder_date_time: "",
                };
                if (!this.users.length) {
                    this.getUsers();
                }
                if (!this.stages.length) {
                    this.getStages();
                }
            },
            getUsers() {
                let vm = this;
                const usersUri = vm.$store.getters.user?.role === "Team lead" ? "users/getTeamLeadEmployees" : "users/getUsers";
                vm.$store
                    .dispatch("post", { uri: usersUri })
                    .then(function (response) {
                        vm.users = response.data.data || [];
                    })
                    .catch(function (error) {
                        vm.$store.dispatch("error", error.response?.data?.message || "Unable to load users");
                    });
            },
            getStages() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "stages/getStage" })
                    .then(function (response) {
                        vm.stages = response.data.data || [];
                    })
                    .catch(function (error) {
                        vm.$store.dispatch("error", error.response?.data?.message || "Unable to load stages");
                    });
            },
            saveComment() {
                let vm = this;
                if (
                    !vm.newComment.user_id ||
                    !vm.newComment.stage_id ||
                    !vm.newComment.next_stage_id ||
                    !String(vm.newComment.comment || "").trim() ||
                    !vm.newComment.reminder_date_time
                ) {
                    vm.$store.dispatch("error", "User, present stage, next stage, comment, and reminder date are required");
                    return;
                }
                const payload = {
                    school_id: Number(vm.school.school_id || vm.commentMeta.school_id),
                    user_id: Number(vm.newComment.user_id),
                    stage_id: Number(vm.newComment.stage_id),
                    next_stage_id: Number(vm.newComment.next_stage_id),
                    comment: vm.newComment.comment,
                    reminder_date_time: moment(vm.newComment.reminder_date_time).format("YYYY-MM-DDTHH:mm:ss"),
                };
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "sessionComments/addSessionComments", data: payload })
                    .then(function (response) {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        document.getElementById("closeSchoolCommentModal")?.click();
                        vm.commentMeta.page = 1;
                        vm.loadComments();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.$store.dispatch("error", error.response?.data?.message || "Unable to add comment");
                    });
            },
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.create();
                } else {
                    vm.update();
                }
            },
            create() {
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "school/addSchool", data: vm.school };
                vm.$store
                    .dispatch("post", uri)
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "School is successfully created");
                        vm.$router.push("/schools");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            update() {
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "school/updateSchool", data: vm.school };
                vm.$store
                    .dispatch("post", uri)
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "School is successfully updated");
                        vm.$router.push("/schools");
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            discard() {
                let vm = this;
                vm.school.school_name = "";
                vm.school.board = "";
                vm.school.district_id = "";
                vm.school.address = "";
                vm.school.place = "";
                vm.school.pincode = "";
                vm.school.school_strength = "";
                vm.$refs.school_name.focus();
                vm.errors = [];
                vm.status = true;
            },
        },
    };
</script>
<style scoped>
    .text-wrap {
        white-space: normal;
        word-break: break-word;
    }
    .width-75 {
        width: 75px;
    }
</style>
